import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getFailureSummariesState = (state) => get(state, 'failureSummaries');
export const getSummaries = createSelector(
  getFailureSummariesState,
  (state) => get(state, 'summaries'),
);
